var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.consultandoElBack } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-3 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.datosGenerales"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.nombreActividad"
                            )} ${
                              _vm.$v.actividadForm.nombreActividad?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-nombre-acividad",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-nombre-actividad",
                              placeholder: _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.nombreActividad"
                              ),
                              state:
                                !_vm.$v.actividadForm.nombreActividad?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.nombreActividad,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.actividadForm,
                                  "nombreActividad",
                                  $$v
                                )
                              },
                              expression: "actividadForm.nombreActividad",
                            },
                          }),
                          _vm._v(" "),
                          !(
                            _vm.$v.actividadForm.nombreActividad?.required ??
                            true
                          )
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-badge",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !!_vm.actividadForm.fechaRealizacion,
                              expression: "!!actividadForm.fechaRealizacion",
                            },
                          ],
                          staticClass: "accion-label",
                          attrs: { pill: "", variant: "light" },
                          on: {
                            click: function ($event) {
                              _vm.actividadForm.fechaRealizacion = undefined
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.actividadesRetribucion.acciones.resetField"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.fechaRealizacion"
                            )} ${
                              _vm.$v.actividadForm.fechaRealizacion?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-fecha-realizacion",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              name: "form-fecha-realizacion",
                              placeholder: _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.fechaRealizacion"
                              ),
                              state:
                                !_vm.$v.actividadForm.fechaRealizacion
                                  ?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.fechaRealizacion,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.actividadForm,
                                  "fechaRealizacion",
                                  $$v
                                )
                              },
                              expression: "actividadForm.fechaRealizacion",
                            },
                          }),
                          _vm._v(" "),
                          !(
                            _vm.$v.actividadForm.fechaRealizacion?.required ??
                            true
                          )
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-badge",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !!_vm.actividadForm.fechaInicio,
                              expression: "!!actividadForm.fechaInicio",
                            },
                          ],
                          staticClass: "accion-label",
                          attrs: { pill: "", variant: "light" },
                          on: {
                            click: function ($event) {
                              _vm.actividadForm.fechaInicio = undefined
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.actividadesRetribucion.acciones.resetField"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.fechaInicio"
                            )} ${
                              _vm.$v.actividadForm.fechaInicio?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-fecha-inicio",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              name: "form-fecha-inicio",
                              placeholder: _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.fechaInicio"
                              ),
                              state:
                                !_vm.$v.actividadForm.fechaInicio?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.fechaInicio,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "fechaInicio", $$v)
                              },
                              expression: "actividadForm.fechaInicio",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.fechaInicio?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-badge",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !!_vm.actividadForm.fechaTermino,
                              expression: "!!actividadForm.fechaTermino",
                            },
                          ],
                          staticClass: "accion-label",
                          attrs: { pill: "", variant: "light" },
                          on: {
                            click: function ($event) {
                              _vm.actividadForm.fechaTermino = undefined
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.actividadesRetribucion.acciones.resetField"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.fechaTermino"
                            )} ${
                              _vm.$v.actividadForm.fechaTermino?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-fecha-termino",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              name: "form-fecha-termino",
                              placeholder: _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.fechaTermino"
                              ),
                              state:
                                !_vm.$v.actividadForm.fechaTermino?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.fechaTermino,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "fechaTermino", $$v)
                              },
                              expression: "actividadForm.fechaTermino",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.fechaTermino?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label: `${_vm.$t(
                            "apeironGwApp.actividadesRetribucion.campos.modalidad"
                          )} ${
                            _vm.$v.actividadForm.modalidad?.required ==
                            undefined
                              ? ""
                              : " *"
                          }:`,
                          "label-for": "form-modalidad",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.opcionesDeModalidad,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-modalidad",
                                    state:
                                      !_vm.$v.actividadForm.modalidad?.$invalid,
                                  },
                                  model: {
                                    value: _vm.actividadForm.modalidad,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.actividadForm,
                                        "modalidad",
                                        $$v
                                      )
                                    },
                                    expression: "actividadForm.modalidad",
                                  },
                                }),
                                _vm._v(" "),
                                !(
                                  _vm.$v.actividadForm.modalidad?.required ??
                                  true
                                )
                                  ? _c("small", {
                                      staticClass: "text-danger",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t("entity.validation.required")
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-5 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.coberturaTerritorial"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.estadoGeo"
                            )} ${
                              _vm.$v.actividadForm.estado?.required == undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-estado-geo",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "form-estado-geo",
                              options: _vm.opcionesEstadosGeo,
                              state: !_vm.$v.actividadForm.estado?.$invalid,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.consultarMunicipios()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.actividadesRetribucion.mensajes.seleccionarUno"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.actividadForm.estado,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "estado", $$v)
                              },
                              expression: "actividadForm.estado",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.estado?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.municipio"
                            )} ${
                              _vm.$v.actividadForm.municipio?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-municipio",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "form-municipio",
                              options: _vm.opcionesMunicipiosGeo,
                              state: !_vm.$v.actividadForm.municipio?.$invalid,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.actividadesRetribucion.mensajes.seleccionarUno"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.actividadForm.municipio,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "municipio", $$v)
                              },
                              expression: "actividadForm.municipio",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.municipio?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.region"
                            )} ${
                              _vm.$v.actividadForm.region?.required == undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-region",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "form-region",
                              options: [
                                {
                                  text: _vm.actividadForm.region?.descripcion,
                                  value: _vm.actividadForm.region,
                                },
                              ],
                              state: !_vm.$v.actividadForm.region?.$invalid,
                              disabled: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.actividadesRetribucion.mensajes.seleccionarUno"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.actividadForm.region,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "region", $$v)
                              },
                              expression: "actividadForm.region",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.region?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.localidad"
                            )} ${
                              _vm.$v.actividadForm.localidad?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-localidad",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "form-localidad",
                              placeholder: _vm.$t(
                                "apeironGwApp.actividadesRetribucion.campos.localidad"
                              ),
                              state: !_vm.$v.actividadForm.localidad?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.localidad,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "localidad", $$v)
                              },
                              expression: "actividadForm.localidad",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.localidad?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-5 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.categoriaRetribucion"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-group", {
                        attrs: {
                          label: `${_vm.$t(
                            "apeironGwApp.actividadesRetribucion.campos.categoriaRs"
                          )} ${
                            _vm.$v.actividadForm.categoria?.required ==
                            undefined
                              ? ""
                              : " *"
                          }:`,
                          "label-for": "form-categoria",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ ariaDescribedby }) {
                              return [
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.opcionesDeCategoriaRs,
                                    "aria-describedby": ariaDescribedby,
                                    name: "form-categoria",
                                    state:
                                      !_vm.$v.actividadForm.categoria?.$invalid,
                                  },
                                  model: {
                                    value: _vm.actividadForm.categoria,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.actividadForm,
                                        "categoria",
                                        $$v
                                      )
                                    },
                                    expression: "actividadForm.categoria",
                                  },
                                }),
                                _vm._v(" "),
                                !(
                                  _vm.$v.actividadForm.categoria?.required ??
                                  true
                                )
                                  ? _c("small", {
                                      staticClass: "text-danger",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t("entity.validation.required")
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.subcategoriaRs"
                            )} ${
                              _vm.$v.actividadForm.subCategoria?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-subcategoria",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "form-subcategoria",
                              options: _vm.opcionesDeSubategoriaRs,
                              state:
                                !_vm.$v.actividadForm.subCategoria?.$invalid,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.actividadesRetribucion.mensajes.seleccionarUno"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.actividadForm.subCategoria,
                              callback: function ($$v) {
                                _vm.$set(_vm.actividadForm, "subCategoria", $$v)
                              },
                              expression: "actividadForm.subCategoria",
                            },
                          }),
                          _vm._v(" "),
                          !(_vm.$v.actividadForm.subCategoria?.required ?? true)
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-5 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.problemaONecesidad"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.problemaONecesidad"
                            )} ${
                              _vm.$v.actividadForm.problemaAtendido?.required ==
                              undefined
                                ? ""
                                : " *"
                            }:`,
                            description: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.problemaONecesidadDesc"
                            ),
                            "label-for": "form-problema-necesidad",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-problema-necesidad",
                              rows: "4",
                              state:
                                !_vm.$v.actividadForm.problemaAtendido
                                  ?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.problemaAtendido,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.actividadForm,
                                  "problemaAtendido",
                                  $$v
                                )
                              },
                              expression: "actividadForm.problemaAtendido",
                            },
                          }),
                          _vm._v(" "),
                          !(
                            _vm.$v.actividadForm.problemaAtendido?.required ??
                            true
                          )
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-5 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.objetivoActividad"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.objetivoActividad"
                            )} ${
                              _vm.$v.actividadForm.objetivoActividad
                                ?.required == undefined
                                ? ""
                                : " *"
                            }:`,
                            "label-for": "form-objetivo-actividad",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-objetivo-actividad",
                              rows: "4",
                              state:
                                !_vm.$v.actividadForm.objetivoActividad
                                  ?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.objetivoActividad,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.actividadForm,
                                  "objetivoActividad",
                                  $$v
                                )
                              },
                              expression: "actividadForm.objetivoActividad",
                            },
                          }),
                          _vm._v(" "),
                          !(
                            _vm.$v.actividadForm.objetivoActividad?.required ??
                            true
                          )
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-5 mb-3" }, [
                    _c("h4", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.descripcionAcciones"
                            )
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "linea-horizontal-roja" }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: `${_vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.descripcionAcciones"
                            )} ${
                              _vm.$v.actividadForm.descripcionAcciones
                                ?.required == undefined
                                ? ""
                                : " *"
                            }:`,
                            description: _vm.$t(
                              "apeironGwApp.actividadesRetribucion.campos.descripcionAccionesDesc"
                            ),
                            "label-for": "form-descripcion-acciones",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              name: "form-descripcion-acciones",
                              rows: "4",
                              state:
                                !_vm.$v.actividadForm.descripcionAcciones
                                  ?.$invalid,
                            },
                            model: {
                              value: _vm.actividadForm.descripcionAcciones,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.actividadForm,
                                  "descripcionAcciones",
                                  $$v
                                )
                              },
                              expression: "actividadForm.descripcionAcciones",
                            },
                          }),
                          _vm._v(" "),
                          !(
                            _vm.$v.actividadForm.descripcionAcciones
                              ?.required ?? true
                          )
                            ? _c("small", {
                                staticClass: "text-danger",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.esReadOnly
                ? _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            attrs: {
                              type: "button",
                              disabled: _vm.$v.$invalid,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.guardar()
                              },
                            },
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }